import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {connect} from "react-redux";

// component
import XailingRoutList from "./_list";
import XailingRoutForm from "./_form";
import RoutSchedule from "../routSchedule/routSchedule";
import {ButtonNew} from "../../../components/buttons/buttonsActions";

// actions
import {setApp, clearState} from "../../../redux/actions/generalActions/mainActions";

const XailingRout = ( props ) => {
	const [editMode, setEditMode] = useState(false);
	const [item, setItem] = useState();

	// Modo de vista: LIST, FORM
	const [viewMode, setViewMode] = useState("LIST")

	useEffect(() => {
		if (props.app !== null)
			props.setApp(props.app);

		return () => {
			props.clearState()
		}
	},[])

	const setForm = (editModeP, data, viewModeP) => {
		setEditMode(editModeP ? editModeP : editMode);
		setItem(data);
		setViewMode(viewModeP ? viewModeP : "LIST")
	}

	const updateItem = (item) => {
		setItem(item)
	}

	return (
		<>
			{/*--------------------------------------------------------------------------------*/}
			{/* Header*/}
			{/*--------------------------------------------------------------------------------*/}
			<Row>
				<Col md="12">
					<div className="d-flex align-items-center">
						{
							viewMode === "LIST" ?
								<div className="ml-auto paddingAdd">
									<ButtonNew onClick={() => setForm(null, null, "FORM")}/>
								</div> : null
						}
					</div>
				</Col>
			</Row>
			<Row>
				<Col md="12">
					{(
						function() {
							switch (viewMode) {
								case "LIST" :
									return <XailingRoutList
										setForm={setForm}
										app={props.app}
									/>
								case "FORM" :
									return <XailingRoutForm
										setForm={setForm}
										updateItem={updateItem}
										item={item}
										editMode={editMode}
										app={props.app}
									/>
								case "SCHEDULE" :
									return <RoutSchedule
										setForm={setForm}
										updateItem={updateItem}
										item={item}
										editMode={editMode}
										app={props.app}
									/>
								default:
									return null;
							}
					})()}
				</Col>
			</Row>
		</>
	);
}

const mapStateToProps = state => ({});

const mapActionsToProps = ({
	clearState,
	setApp
});

export default connect(mapStateToProps, mapActionsToProps)(XailingRout)